const getRequest = (url,headers) => {

    return handleResponse(
        fetch(url,
            {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'ozt': localStorage.getItem(window.hierarchicalToken),
                    "accId":headers&&headers["accId"],
                    "appCode":headers&&headers["appCode"]
                },
            }));
}

const postRequest = (url, data,headers) => {

    return handleResponse(
        fetch(url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'ozt': localStorage.getItem(window.hierarchicalToken),
                    "accId":headers&&headers["accId"],
                    "appCode":headers&&headers["appCode"]           
                },
                body: JSON.stringify(data)
            }));
}

const putRequest = (url, data) => {

    return handleResponse(
        fetch(url,
            {
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'ozt': localStorage.getItem(window.hierarchicalToken),
                },
                body: JSON.stringify(data)
            }));
}

const deleteRequest = (url, data) => {

    return handleResponse(
        fetch(url,
            {
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                    'ozt': localStorage.getItem(window.hierarchicalToken),
                },
                body: JSON.stringify(data)
            }));
}

const handleResponse = (promise) => {

    return promise.then(response => {

        if (!response.ok) {

            if (response.status === 401) {

                

                return { success: false };
            }

            return Promise.reject(response.statusText);
        }

        return response.json();
    });
}

export const requestTool = {
    getRequest,
    postRequest,
    putRequest,
    deleteRequest
}

export default requestTool;